import { Theme } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { TStore } from '../../../../../../state/store';

interface Props {
  pendingQuestions: boolean;
}

class VerificationEmploymentDetailsBadge extends React.Component<Props & WithStyles<typeof styles>> {
  public render(): React.ReactNode {
    const { classes, pendingQuestions } = this.props;

    return pendingQuestions ? <div data-testid="verification-employment-details-badge" className={classes.root} /> : null;
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.error.main,
      borderRadius: '50%',
      textAlign: 'center',
      minWidth: 24,
      minHeight: 24,
    },
  });

const mapStateToProps = (store: TStore) => ({
  pendingQuestions: store.userData.pendingQuestions,
});

export default connect(mapStateToProps)(withStyles(styles)(VerificationEmploymentDetailsBadge));
